<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/research"></imgBigCards>
    <!-- 输入框 -->
    <div class="box-input">
      <inputBox @query="inputBoxClick"></inputBox>
    </div>
    <div class="title-box">
      <div class="title">
        <!-- 面包屑 -->
        <!-- <div class="title-left">
          <el-breadcrumb>
            <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
            <el-breadcrumb-item to="/layout/list/teacherHand"
              >教师助手</el-breadcrumb-item
            >
            <el-breadcrumb-item to="/layout/list/research"
              >课题研究</el-breadcrumb-item
            >
            <el-breadcrumb-item>正文</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->

        <!-- 加入收藏 -->
        <div
          v-if="mydata.articleInfo.is_collect === 0"
          class="title-right"
          @click="isCollect"
        >
          <el-icon><Star /></el-icon>
          <p>加入收藏</p>
        </div>
        <!-- 取消收藏 -->
        <div v-else class="title-right" @click="isCollect">
          <el-icon class="collectTrue"><Star /></el-icon>
          <p class="collectTrue">取消收藏</p>
        </div>
      </div>
    </div>

    <div class="box-content">
      <div class="content-left">
        <div class="left-one">
          <div class="one-title">
            <p>
              {{ mydata.articleInfo.title }}
              <!-- 天利公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利中移动和华为签署专利运营合作备忘录知方公司与中国科学院微电子所、中移动和华为签署专利运营合作备忘录运营合作备忘录 -->
            </p>
            <P>
              <span
                >发表时间：
                <!-- 2023-11-07 -->
                <!-- 后端会返回 10位的数字===秒   13位的数字===毫秒 -->
                {{
                  dayjs(mydata.articleInfo.release_time * 1000).format(
                    "YYYY-MM-DD"
                  )
                }}
              </span>
              <span style="margin-right: 34px"
                >来源：{{ mydata.articleInfo.source }}</span
              >
              <span
                >关键词：
                <span
                  v-for="(item, index) in mydata.articleInfo.tags"
                  :key="index"
                  style="margin-right: 10px"
                  >{{ item.name }}</span
                >
              </span>
            </P>
          </div>
          <div class="one-content">
            <!-- <img src="@/assets/image 13 (1).png" alt="" /> -->
            <!-- <img
              v-complete:src="mydata.articleInfo.image"
              alt=""
            /> -->
            <p class="tableA" v-html="mydata.articleInfo.content"></p>
          </div>

          <div class="one-button">
            <el-button
              type="primary"
              @click="teacherButton"
              v-if="mydata.is_time"
              >我要加入</el-button
            >
            <el-button type="info" disabled v-else>活动已结束</el-button>
          </div>

          <div class="one-foot">
            <p
              style="cursor: pointer"
              @click="goPrevOrNext(mydata.articleInfo.prev.id)"
              v-if="mydata.articleInfo.prev?.title !== undefined"
            >
              上一篇：{{ mydata.articleInfo.prev?.title }}
            </p>
            <p
              style="cursor: pointer"
              @click="goPrevOrNext(mydata.articleInfo.next.id)"
              v-if="mydata.articleInfo.next?.title !== undefined"
            >
              下一篇： {{ mydata.articleInfo.next?.title }}
            </p>
          </div>
        </div>
        <div class="left-two">
          <div class="left-two-box">
            <column title="活动成果" path="/layout/list/projectAchievements">
              <template #abc>
                <ul>
                  <li
                    class="my-li hover-change-color"
                    v-for="(item, index) in mydata.articleListArr"
                    :key="index"
                    style="cursor: pointer"
                    @click="activeClick(item.id)"
                  >
                    <p>{{ item.title }}</p>
                    <p>
                      {{ dayjs(item.release_time * 1000).format("YYYY-MM-DD") }}
                    </p>
                  </li>
                </ul>
              </template>
            </column>
          </div>
        </div>
      </div>
      <!-- 右侧推荐区域 -->
      <div class="content-right">
        <!-- 新书上架 -->
        <rightCardNewBook
          title="新书上架"
          :path="mydata.myPath"
        ></rightCardNewBook>
        <!-- 必刷好题 -->
        <rightCardProblem
          title="热门资源"
          path="/layout/list/boutiqueTaobaoQuestions"
        ></rightCardProblem>
      </div>
    </div>
  </div>
</template>

<script setup>
// 新书上架
import rightCardNewBook from "@/components/rightCardNewBook/index2.vue";
// 必刷好题
import rightCardProblem from "@/components/rightCardProblem/index.vue";

import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock, CollectionTag } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";

import { reactive, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

// 引入加入收藏、取消收藏接口
import { addFavoritesList } from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";
// 新书推荐
import { bookNew } from "@/api/addedServices/index.js";
//获取淘题搜索列表接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";
// 引入接口
import { articleList } from "@/api/home/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  bookNew: [], // 新书推荐
  examSearchList: [], // 热门资源
  articleListArr: [], // 活动成果
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId("/layout/list/projectAchievements"), // 栏目id值
    search: "", // 搜索查询
    stage: "", //学段
    theme: "", //主题
    subject: "", //学科
  },
  column_key: route.path,
  myPath: "",

  
   is_time: false, //报名时间是否结束
});



//报名时间是否结束
function endTimeFn() {
  let nowTime = new Date().getTime(); //现在时间
  let endTime = mydata.articleInfo.end_time * 1000; //报名截止时间
  if (endTime > nowTime) {
    mydata.is_time = true; //可报名
  } else {
    mydata.is_time = false; //不可报名
  }
}


//详情页搜索跳转到课题研究页
function inputBoxClick(type, value) {
  localStorage.setItem("v", value);
  router.push({
    path: "/layout/list/research",
    // query:{
    //   search:value
    // }
  });
}

function getPathByUserInfo() {
  if (mydata.userInfo.gradeId) {
    let gradeIdOptions = JSON.parse(
      localStorage.getItem("gradeIdOptions")
    ).find((item) => {
      return item.id === mydata.userInfo.gradeId;
    });
    if (gradeIdOptions.pid === 9) {
      mydata.myPath = "/layout/list/highSchoolBooks";
    }
    if (gradeIdOptions.pid === 10) {
      mydata.myPath = "/layout/list/middleSchoolBooks";
    }
    if (gradeIdOptions.pid === 7) {
      mydata.myPath = "/layout/list/primarySchoolBooks";
    }
    //  console.log(gradeIdOptions);
  } else {
    mydata.myPath = "/layout/list/highSchoolBooks";
  }
}
getPathByUserInfo();

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/researchDetails")) {
      return;
    }
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log("文章接口", res.data);
    mydata.articleInfo = res.data;

      endTimeFn(); //报名时间是否结束

    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.articleInfo.title;
  });
}

// init();

// 新书推荐
function bookNewFN() {
  bookNew().then((res) => {
    mydata.bookNew = res.data.list;
  });
}
bookNewFN();

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.articleInfo.is_collect !== 0) {
    // 调用取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 3,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 3,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

// ///我要加入按钮————教师活动报名
// function teacherButton() {
//   router.push({
//     path: "/layout/list/thisEventRegistrationTeacher",
//     query: { id: mydata.articleId },
//   });
// }

///我要加入按钮————教师活动报名
function teacherButton() {
  //如果登录了，就正常跳转；否则，弹窗提醒未登录，然后跳转到登录页面
  if (mydata.userInfo.jwt) {
    // 如果身份是学生，那么正常跳转；否则，弹窗提醒一下
    if (mydata.userInfo.user_role === 3) {
      // 跳转地址到表单页面
      router.push({
        path: "/layout/list/thisEventRegistrationTeacher",
        query: { id: mydata.articleId },
      });
    } else {
      ElMessage({
        message: "此活动仅对教师开放，感谢支持",
        type: "error",
      });
    }
  } else {
    // 弹窗提醒未登录
    ElMessage({
      message: "当前用户未登录",
      type: "error",
    });
    // 跳转到登录页面
    router.push({
      path: "/login/nowLogin",
    });
  }
}
















// 淘题搜索列表
function examSearchListFN() {
  examSearchList({ is_recommended: 1 }).then((res) => {
    mydata.examSearchList = res.data.list;
  });
}
examSearchListFN();

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}
articleListFn();

function goPrevOrNext(id) {
  if (id === undefined) {
    return;
  }

  router.push({
    path: "/layout/list/researchDetails",
    query: { id },
  });
}

//活动成果内容点击
function activeClick(id) {
  router.push({
    path: "/layout/list/projectAchievementsDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.my-li {
  > p:nth-of-type(1) {
    width: calc(100% - 100px);
    position: static !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    margin-bottom: 16px;
    // border-bottom: 1px solid hsla(0, 0%, 80%, 0.8);
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }
  ////////最顶部的title
  .title-box {
    width: 343px;
    margin: 0 auto;
    // border: 1px solid blue;
    margin-top: 20px;
    margin-bottom: 10px;

    .title-right {
      // width:60px;
      font-size: 16px;
      font-weight: 400;
      color: #bbbdbf;
      display: flex;
      align-items: center;
      justify-content: end;

      .el-icon {
        font-size: 24px;
        font-weight: 400;
        margin-right: 4px;
      }
    }
    .title-right:hover {
      color: #009de0;
    }
  }
  // :deep(.books-details.layout-router-view.box1){
  //   margin-bottom:0px !important;
  // }
  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    // margin-top: 21px;
    // margin-bottom:16px;
    // display: flex;
    // justify-content: space-between;

    /////左边内容部分
    .content-left {
      width: 375px;
      // height: 1608px;
      // border: 1px dashed rgb(102, 255, 0);
      background-color: #f9f9f9;
      // margin:0 auto;
      ////左边---第一个模块---卷子标题盒子
      .left-one {
        // width: 860px;
        background-color: #ffffff;
        padding: 20px 16px;
        .one-title {
          width: 343px;
          // height: 90px;
          // border: 1px solid red;
          p:nth-of-type(1) {
            min-height: 28px;
            font-size: 18px;
            font-weight: 700;
            color: #333333;

            line-height: 28px;
            // height: 56px;
            display: -webkit-box;
            -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            text-overflow: ellipsis; //文本溢出 用省略号显示
            -webkit-line-clamp: 2; //几行
            overflow: hidden;
          }
          p:nth-of-type(2) {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #888888;
            margin-top: 12px;
            > span {
              margin-right: 34px;
            }
          }
        }
        .one-content {
          width: 343px;
          // height:1824px;
          // border: 1px solid blue;
          margin-top: 24px;
          // img {
          //   width: 720px;
          //   height: 480px;
          //   margin: 0 auto;
          //   display: block;
          //   // border:1px solid yellow;
          // }
          p {
            margin-top: 24px;
            white-space: pre-wrap;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            // color:red;
          }
        }
        .one-button {
          //按钮
          :deep(.el-button) {
            width: 170px;
            height: 46px;
            border-radius: 30px;
            color: #ffffff;
            font-size: 14px;
            font-weight: 400;
            margin: 0 auto;
            display: block;
            margin-top: 26px;
          }
        }
        .one-foot {
          width: 343px;
          // height: 84px;
          // border: 1px solid red;
          border-top: 1px dashed #cccccc;
          margin-top: 26px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //文本溢出 用省略号显示
            overflow: hidden;
          }
          p:nth-of-type(1) {
            margin-top: 24px;
          }
          p:nth-of-type(2) {
            margin-top: 16px;
          }
          p:hover {
            color: #009de0;
          }
        }
      }

      ////左边---第二个模块
      .left-two {
        margin: 0 auto;
        margin-bottom: 16px;
        overflow: hidden;
        //////活动成果部分
        .left-two-box {
          width: 800px;
          // height: 228px;
          // border: 1px dashed yellow;
          overflow: hidden;

          :deep(.box-column) {
            height: 100%;
            margin-top: 16px;
            li:hover {
              p:nth-of-type(2) {
                color: #009de0;
              }
            }

            li {
              margin-left: 20px;
              // display: flex;
              // justify-content: space-between;
              // align-items: center;
              margin-bottom: 10px;
              // border: 1px solid red;
              position: relative;
              p:first-of-type {
                font-size: 14px;
                margin-bottom: 8px;
                line-height: 24px;
                white-space: nowrap; //不折行
                text-overflow: ellipsis; //文本溢出 用省略号显示
                overflow: hidden;
              }
              p:nth-of-type(2) {
                font-size: 14px;
                font-weight: 400;
                color: #888888;
                position: absolute;
                right: 0px;
                top: 2px;
              }
            }
            li:nth-last-of-type(1) {
              margin-bottom: 0px;
            }
            // .column-title {
            //   border-bottom: 1px solid #cccccc;
            //   > p {
            //     // display: none;
            //   }
            // }
            .column-content {
              height: 220px;

              overflow: hidden;
              overflow-y: auto;
            }
          }
        }
      }
    }

    /////右边推荐区域
    .content-right {
      :deep(.box-column) {
        .column-title {
          > p {
            display: block;
          }
        }
      }

      :deep(.box-column.column2){
        margin-bottom:0px;
      }
    }
  }
}
:deep(.left-two-box .column-content) {
  height: 156px !important;
}


</style>
